/** DISCLAIMER
* "Property of OSF Global Services, Inc., (with its brand OSF Commerce). OSF remains the sole owner of all right, title and interest in the software.
* Do not copy, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein."
*/

/* global cbtSitePreferences */
var liveClick = [];
var impressionCounter = 0;
var customerSortingResults = "";
var cbtUtil = require("./cbtUtil");

class CBTController {

    /**
     * find, parse and add to dataLayer data-cbt from all tags in node
     * @param {Object} node - DOM node, inside which will be search
     */
    static findAllDataDOM(node) {
        let allCBTData = node.querySelectorAll("[data-cbt]"),
            impressionsContainer = [],
            dataCollectionObj = {};

        if (!allCBTData.length) {
            return false;
        }

        for (let i = 0; i < allCBTData.length; i++) {
            let tempNode = allCBTData[i];
            dataCollectionObj = cbtUtil.parseJSON(tempNode.getAttribute("data-cbt"));
            if (!dataCollectionObj) {
                continue;
            }
            if (dataCollectionObj.event === "ImpressionsUpdate") {
                dataCollectionObj.ecommerce.impressions.position = impressionCounter;
                impressionCounter++;
            }
            if (dataCollectionObj.event === "eeListView" && dataCollectionObj.listType !== "Search module") {
                //Handle specific cases when customer sorts by method
                if (customerSortingResults) {
                    dataCollectionObj.listName += " > Sort > " + customerSortingResults;
                }
                cbtUtil.dataPush(dataCollectionObj);
            }
            if (dataCollectionObj.eeAction === "eeProductDetail"
            || dataCollectionObj.event === "eeListView" && dataCollectionObj.listType === "Search module"
            || dataCollectionObj.action === "Search" && dataCollectionObj.label // Handle Search Bar input
            || dataCollectionObj.cat55 && dataCollectionObj.cat55.length > 0
            || dataCollectionObj.event === "virtualPageview"
            || (dataCollectionObj.event === "openMiniCart" && $(window).width() > 768) // Only on desktop
            ) {
                cbtUtil.dataPush(dataCollectionObj);
            }
            if (!dataCollectionObj.eventTypes || !dataCollectionObj.event) {
                continue;
            }

            let eventTypes = dataCollectionObj.eventTypes.split(",");

            if (eventTypes.indexOf("show") != -1) {
                // Handle show events that appered as a result of a click in specific cases
                // i.e. Add Coupon in SG. That way they will appear as Click event.
                if (dataCollectionObj.eventTypes.indexOf("click") !== - 1) {
                    dataCollectionObj.category = "Click";
                    cbtUtil.dataPush(dataCollectionObj);
                    continue;
                }
                if (dataCollectionObj.event.indexOf("show") == -1) {
                    dataCollectionObj.event = "show" + dataCollectionObj.event;
                }
                if (dataCollectionObj.event == "showImpressionsUpdate") {
                    impressionsContainer.push(dataCollectionObj.ecommerce.impressions);
                } else {
                    cbtUtil.dataPush(dataCollectionObj);
                }
                tempNode.removeAttribute("data-cbt");
            }
        }

        if (impressionsContainer.length > 0) {
            let dataLayerObj = {
                "event" : "showImpressionsUpdate",
                "ecommerce": {}
            };
            dataLayerObj.ecommerce.impressions = impressionsContainer;
            cbtUtil.dataPush(dataLayerObj);
        }
    }

    /* Update Product Tile data-cbt attribute with actual position so it works with "Show more" feature */
    static updateTilesPosition(nodes) {
        var productCollection = [];
        var productCounter = -1;

        for (let i = 0; i < nodes.length; i++) {
            let tempNode = nodes[i];
            var dataCollectionObj = cbtUtil.parseJSON(tempNode.getAttribute("data-cbt"));
            if (dataCollectionObj && dataCollectionObj.event === "showProductClick") {
                if (productCollection.indexOf(dataCollectionObj.ecommerce.click.products[0].id) === -1) {
                    productCollection.push(dataCollectionObj.ecommerce.click.products[0].id);
                    productCounter++;
                }
                dataCollectionObj.ecommerce.click.products[0].position = productCounter;
                tempNode.dataset.cbt = JSON.stringify(dataCollectionObj);
            }
        }
    }

    /**
     *  if "link" option enable, set same "data-cbt" to all node childNodes,
     *  to have the same event in clickListenerRun and hoverListenerRun
     */
    static handleLinks(node) {
        const allCBTData = node.querySelectorAll("[data-cbt]");

        if (!allCBTData.length) {
            return false;
        }

        // Call updateTilesPosition to avoid querying document another time
        CBTController.updateTilesPosition(allCBTData);

        function setChildData(childs, data) {
            for (let i = 0; i < childs.length; i++) {
                if (childs[i].nodeType == 1) {
                    if (childs[i].getAttribute("data-cbt")) continue;
                    childs[i].setAttribute("data-cbt", data);
                    if (childs[i].childNodes.length) {
                        setChildData(childs[i].childNodes, data);
                    }
                }
            }
        }

        for (let i = 0; i < allCBTData.length; i++) {
            let tempNode = allCBTData[i];
            const dataStr = tempNode.getAttribute("data-cbt");
            const dataObj = cbtUtil.parseJSON(dataStr);

            if (!dataObj) continue;

            if (typeof dataObj.eventTypes !== "undefined" && dataObj.eventTypes.indexOf("link") != -1) {
                if (tempNode.childNodes.length) {
                    setChildData(tempNode.childNodes, dataStr);
                }
            }

            if (typeof dataObj.eventTypes !== "undefined" && dataObj.eventTypes.indexOf("add") != -1) {
                let dynamicNodes = document.querySelectorAll(dataObj.selector);
                if (dynamicNodes.length) {
                    for (let j = 0; j < dynamicNodes.length; j++) {
                        let tempDynamicNode = dynamicNodes[j];
                        let dataObj = cbtUtil.parseJSON(dataStr);
                        let eventTypes = dataObj.eventTypes.split(",");
                        eventTypes.splice(eventTypes.indexOf("add"), 1);
                        dataObj.eventTypes = eventTypes.join(",");
                        tempDynamicNode.setAttribute("data-cbt", JSON.stringify(dataObj));
                    }
                    tempNode.removeAttribute("data-cbt");
                }
            }
        }
    }

    /**
     * run AJAX listener, to find all (cbt_data in JSON) or (data-cbt in HTML) sent via XMLHttpRequest
     */
    static AJAXListenerRun() {
        var listenerSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function() {
            var callback = this.onreadystatechange;
            this.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    if (this.getAllResponseHeaders().indexOf("application/json") != -1) {
                        var response = cbtUtil.parseJSON(this.responseText);
                        var cbtDataObject = response.cbt_data ? cbtUtil.parseJSON(response.cbt_data) : null;
                        var cbtDataArray = response.cbtDataArray || [];
                        var siteLocation = CBTController.getSiteLocation();

                        CBTController.cbtFormResponseError(response);

                        if (cbtDataObject) {
                            if (cbtDataObject.event === "addToCart") {
                                cbtDataObject.addToCartType = cbtDataObject.addToCartType || siteLocation || "";
                                response.cbt_data = JSON.stringify(cbtDataObject);
                            } else if (cbtDataObject.event === "eeListView") {
                                response.cbt_data = JSON.stringify(cbtDataObject);
                            }
                        }

                        if (response.cbt_data) {
                            cbtUtil.dataPush(response.cbt_data);
                        }

                        cbtDataArray.forEach(function (cbtData) {
                            cbtUtil.dataPush(cbtData);
                        });
                    }

                    if (this.getAllResponseHeaders().indexOf("text/html") != -1) {
                        var container = document.implementation.createHTMLDocument("").documentElement;
                        container.innerHTML = this.responseText;
                        CBTController.findAllDataDOM(container);
                    }
                }
                if (callback) {
                    callback.apply(this, arguments);
                }
            };
            listenerSend.apply(this, arguments);
        };
    }

    //run DOM updates listener, to find all cbt-data added to DOM
    static DOMListenerRun() {
        var timeout = null;
        let observer = new MutationObserver(function() {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function() {
                CBTController.handleLinks(document);
            }, 1000);
        });
        const targetNode = document.body;
        const config = { childList: true, subtree: true };
        observer.observe(targetNode, config);
    }

    static clickListenerRun() {
        $("body").on("click", "[data-cbt]", function () {
            let $node = $(this);
            let data = cbtUtil.parseJSON($node.attr("data-cbt"));
            if (data && data.eventTypes && data.eventTypes.indexOf("click") != -1) {
                var siteLocation = CBTController.getSiteLocation();

                if ( // do not make the push if on mobile menu (click does not navigate)
                    data.event === "navigationLinkClick" &&
                    $node.hasClass("dropdown-toggle") &&
                    $("#sg-navbar-collapse").hasClass("in")
                ) {
                    return;
                }

                if (data.event === "navigationLinkClick" && data.siteLocation === "") {
                    data.siteLocation = siteLocation;
                }

                var isSelectedFilter = $node.parents(".category-filter-btn").find(".category-filter-input").is(":checked");

                if (data.event === "filterBy" && isSelectedFilter) {
                    return;
                }

                if (liveClick.indexOf(data.event) == -1) {
                    liveClick.push(data.event);
                    setTimeout(function () {
                        liveClick.splice(liveClick.indexOf(data.event), 1);
                    }, 10);
                } else {
                    return;
                }
                cbtUtil.dataPush(data);
            }
        });
    }

    static changeListenerRun() {
        document.addEventListener("change", function(event) {
            if (event && event.target && event.target.getAttribute("data-cbt")) {
                let node = event.target,
                    data = cbtUtil.parseJSON(node.getAttribute("data-cbt"));
                if (data && data.eventTypes && data.eventTypes.indexOf("change") != -1) {
                    if (node.options) {
                        data.label = node.options[node.options.selectedIndex].text;
                    }
                    if (typeof node.attributes["type"] !== "undefined" && node.attributes["type"]["nodeValue"] == "checkbox") {
                        if (!data.label) {
                            data.label = node.checked ? "checked" : "unchecked";
                        }
                    }
                    if (!data.label) {
                        data.label = node.value;
                    }
                    if (!data.action) {
                        data.action = "change";
                    }
                    data.category = "Click";

                    cbtUtil.dataPush(data);
                }
            }
        });
    }

    static hoverListenerRun() {
        let timeout = null;
        document.addEventListener("mouseover", function(event) {
            if (event && event.target && event.target.getAttribute("data-cbt")) {
                const hoverDelay = cbtSitePreferences.CBT_HOVER_DELAY || 1000; // delay for hover event (ms)
                let node = event.target,
                    data = cbtUtil.parseJSON(node.getAttribute("data-cbt"));
                if (!data) {
                    return;
                }
                if (data.eventTypes && data.eventTypes.indexOf("hover") != -1) {
                    timeout = setTimeout(function () {
                        if (node.options) {
                            data.label = node.options[node.options.selectedIndex].text;
                        }
                        if (!data.action) {
                            data.action = "hover";
                        }
                        data.category = "Hover";
                        cbtUtil.dataPush(data);
                    }, hoverDelay);
                }
            }
        });

        document.addEventListener("mouseout", function(event) {
            if (event && event.target && event.target.getAttribute("data-cbt")) {
                clearTimeout(timeout);
            }
        });
    }

    static getURL(str) {
        try {
            return new URL(str).hostname;
        } catch (error) {
            return null;
        }
    }

    static getSiteLocation() {
        var siteLocation = $("#cbt-site-location").data("site-location") || "";
        var url = new URL(window.location.href);
        var q = url.searchParams.get("q");

        if (q) {
            siteLocation = "Search";
        }

        if (!siteLocation) {
            siteLocation = $(".page").data("cbt-sitelocation") || "";
        }

        return siteLocation;
    }

    static outboundLinkClicks() {
        $(document).on("click", "a", function () {
            var $this = $(this);
            var currentLink = $this.attr("href");
            var currentDomain = CBTController.getURL(currentLink);

            if (!currentDomain || $this.hasClass("eretailers-button")) {
                return;
            }

            var siteDomain = window.location.hostname || "";
            var isCurrentSiteDomain = currentDomain === siteDomain;

            if (isCurrentSiteDomain) {
                return;
            }
            var redirectionLinkName = $this.data("en") || $this.text() || currentLink || "";
            var dataLayer = {
                "event": "outboundLinkClick",
                "redirectionDomainName": currentDomain,
                "redirectionLinkName": redirectionLinkName
            };

            cbtUtil.dataPush(dataLayer);
        });
    }

    /**
     * Do a push if error in form submission response
     * @param {Object} response - json response object
     */
    static cbtFormResponseError(response) {
        if (!response.cbtPushFormErrors || !response.fields) {
            return;
        }

        const fields = Object.keys(response.fields);
        if (fields.length === 0) {
            return;
        }

        let $form = $("[name='" + fields[0] + "']").closest(".form-cbt-push-errors");
        if ($form.length === 0) {
            // submit button might be outside form tags
            $form = $(".form-cbt-push-errors [name='" + fields[0] + "']").first();
            if ($form.length === 0) {
                return;
            }
        }

        let dataLayer = {
            event: "formError",
            formType: $("#checkout-login").length > 0 ? "Checkout" : $form.data("cbt-form-type") || "",
            formName: $form.data("cbt-form-name") || "",
            fieldName: fields.map((e) => e.replace("dwfrm_", "")).join("|")
        };
        cbtUtil.dataPush(dataLayer);
    }

    static customerSortsResults() {
        $(".container").on("change", "select#sort-order-clp", function() {
            var selectedOption = $(this).find("option:selected");
            var sortOption = selectedOption.length ? selectedOption : $(this).find("option[selected]");
            const sortingOption = sortOption.data("id");
            customerSortingResults = sortingOption ? sortingOption : "";
        });
    }
}

/**
 * initial cbt-data search and dataLayer push on page
 * AJAX listener run
 */

document.addEventListener("DOMContentLoaded", function() {
    CBTController.findAllDataDOM(document);
    CBTController.AJAXListenerRun();
    CBTController.DOMListenerRun();
    CBTController.outboundLinkClicks();

    if (cbtSitePreferences.CBT_CLICK) {
        CBTController.clickListenerRun();
        CBTController.changeListenerRun();
    }

    if (cbtSitePreferences.CBT_HOVER) {
        CBTController.hoverListenerRun();
    }
});

// After gtm.js file is loaded
window.addEventListener("load", function () {
    CBTController.customerSortsResults();
});
